import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { EnduserToolsPage } from "@/app/enduser/components/enduser-tools-page";
import { RootLoader } from "@/components/custom/root-loader";

export const Route = createFileRoute("/eu/")({
  component: () => (
    <Suspense fallback={<RootLoader />}>
      <EnduserToolsPage />
    </Suspense>
  ),
});
